import { FC } from 'react';
import EmailNotesGroup from 'modules/events/groups/EmailNotesGroup';
import useEmailConfigurationStep from 'modules/events/routes/CreateOnlineMeeting/Steps/EmailConfigurationStep/EmailConfigurationStep.hook';
import Box from 'yoda-ui/Box';

const EmailConfigurationStep: FC = () => {
  useEmailConfigurationStep();
  return (
    <Box>
      <EmailNotesGroup />
    </Box>
  );
};

export default EmailConfigurationStep;
